import styled from 'styled-components';
import colors from 'const/style/colors';

const FloatingFrame = styled.div`
  position:fixed;
  width:100%;
  height:100%;
  top:0;
  left:0;
  display:flex;
  flex-direction:row;
  justify-content:center;
  align-items:center;
  z-index:999;
  .dimmer {
    position:absolute;
    width:100%;
    height:100%;
    top:0;
    left:0;
    background:${colors.CFFFFFF};
    opacity:0.9;
    z-index:1
  }
  .frame-floating-content {
    z-index:2;
  }
`;

export default FloatingFrame;